export const GET_CONTRACTOR_CLASSIFICATION = 'GET_CONTRACTOR_CLASSIFICATION';
export const UNATORIZED = 'UNATORIZED';
export const ERROR_CONTRACTOR_CLASSIFICATION = 'ERROR_CONTRACTOR_CLASSIFICATION';
